import { ButtonPrimary } from "@nova/component-btn"
import useAppPages from "integrations/nextjs/routing/useAppPages"

export const ReturnToWorkspaceButton = () => {
    const { redirectToRootPage } = useAppPages()

    return <ButtonPrimary onClick={redirectToRootPage} title="Back to workspace" />
}
